import React from 'react';
import { getIntlMessage, getIntlMessageComponent, systemDangerNotification } from './utilHelpers';

export const ENTITY_USER = 'user';
export const ENTITY_PROJECT = 'project';
export const ENTITY_FILE = 'file';

/**
 * Метод изменяет значение language в localStorage
 * @param language
 * @param alias
 */
export const setCompanyLanguage = (language, alias) => {
  if (!language || !alias) {
    return;
  }

  localStorage.setItem(`${alias}-language`, language);
};

/**
 * Метод проверяет лимиты компании по выбранной сущности
 * @param entity
 * @param company
 * @param rate
 * @returns {boolean|boolean}
 */
export const checkCompanyLimits = (entity, company, rate) => {
  if (!company || !rate) {
    return false;
  }

  // limit === null - безлимит
  const checkLimit = (limit, count) => (limit !== null ? limit > count : true);

  switch (entity) {
    case ENTITY_FILE: {
      const limit = rate.get('storageLimit');
      // Тарифное значение измеряется в Кб, текущее кол-во в компании в байтах
      return checkLimit(limit === null ? limit : limit * 1024, company.get('filesSizesCount'));
    }
    case ENTITY_USER:
      return checkLimit(rate.get('usersLimit'), company.get('usersCount'));
    case ENTITY_PROJECT:
      return checkLimit(rate.get('projectsLimit'), company.get('projectsCount'));
    default:
      return false;
  }
};

/**
 * Метод создает нотификацию в углу приложения
 * @param entity
 * @param alias
 */
export const showLimitNotification = (entity, alias) => {
  systemDangerNotification(
    <React.Fragment>
      <div>{getIntlMessage(`user.company.limit.${entity}`)}</div>
      <div className="gx-mt-2">
        {getIntlMessageComponent('user.company.limit.after', {
          link: (content) => (
            <a href={`/WS${alias}/settings/rate`} target="_blank" rel="noopener noreferrer">
              {content}
            </a>
          ),
        })}
      </div>
    </React.Fragment>,
  );
};
